import {NgModule} from '@angular/core';
import {CapitalizePipe} from '@shared/pipes/capitalize.pipe';
import {ShortenPipe} from '@shared/pipes/shorten.pipe';
import {IconifyPipe} from '@shared/pipes/iconify.pipe';
import {CalendarPipe} from '@shared/pipes/moment/calendar.pipe';
import {FromNowPipe} from '@shared/pipes/moment/from-now.pipe';
import {HasPermissionPipe} from '@shared/pipes/has-permission.pipe';
import {MoneyPipe} from '@shared/pipes/money.pipe';
import {ZeroifyPipe} from '@shared/pipes/zeroify.pipe';
import {DeCamelcasePipe} from '@shared/pipes/de-camelcase.pipe';
import {IntervalFormatterPipe} from '@shared/pipes/interval-formatter.pipe';
import {SearchPipe} from '@shared/pipes/search.pipe';
import {StripeYearPipe} from '@shared/pipes/stripe/stripe-year.pipe';
import {CarTitlePipe} from '@shared/pipes/car/car-title.pipe';
import {MileagePipe} from '@shared/pipes/car/mileage.pipe';
import {MdToHtmlPipe} from './blog/md-to-html.pipe';
import {BodyStylePipe} from '@shared/pipes/car/body-style.pipe';
import {FavCheckerPipe} from '@shared/pipes/fav-vehicle-checker.pipe';
import {SorterPipe} from '@shared/pipes/sorter.pipe';

@NgModule({
  exports: [
    ShortenPipe, IntervalFormatterPipe, SearchPipe, StripeYearPipe, CalendarPipe, IconifyPipe, MileagePipe,
    HasPermissionPipe, ZeroifyPipe, CapitalizePipe, DeCamelcasePipe, FromNowPipe, MoneyPipe, CarTitlePipe, MdToHtmlPipe,
    BodyStylePipe, FavCheckerPipe, SorterPipe
  ],
  declarations: [
    CapitalizePipe, ShortenPipe, SearchPipe, StripeYearPipe, CalendarPipe, IntervalFormatterPipe, FromNowPipe,
    IconifyPipe, HasPermissionPipe, MoneyPipe, ZeroifyPipe, DeCamelcasePipe, CarTitlePipe, MileagePipe, MdToHtmlPipe,
    BodyStylePipe, FavCheckerPipe, SorterPipe
  ]
})

export class PipeModule {
}
